import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConfidenceToClose, ConfidenceToCloseNames } from 'src/app/modules/shared/entities/confidence-to-close.enum';
import { AppInfoService } from 'core/app-info/app-info.service';
import { QuoteListResponse } from 'src/app/modules/pos/quotes/entities/quote-list.class';
import { PriceAsInfo } from 'src/app/modules/shared/entities/price-as-info.class';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { LastQuotesFilters } from '../../entities/last-quotes-filters.class';
import { LastQuoteListItem } from '../../entities/quote-list-item.class';
import { PriceAsService } from '../../services/price-as-service/price-as.service';
import { QuoteType } from '../../entities/quote-type.enum';
import { QuoteStatus } from '../../entities/quote-status.enum';

@Component({
  selector: 'app-last-quotes-list',
  templateUrl: './last-quotes-list.component.html',
  styleUrls: ['./last-quotes-list.component.scss'],
  standalone: false
})
export class LastQuotesListComponent implements OnInit {

  appStrings: AppLocalization;
  dateFormat = this.appInfoService.dateFormat;
  currencySymbol = '';
  isLoading = false;

  displayedColumns = [
    'accountName',
    'confidence',
    'quoteNumber',
    'expiredDate',
    'total',
    'action'
  ];
  quoteType = QuoteType;
  quoteStatus = QuoteStatus;

  quoteList = [];
  ConfidenceToClose = ConfidenceToClose;
  ConfidenceToCloseNames = ConfidenceToCloseNames;

  constructor(
    public dialogRef: MatDialogRef<LastQuotesListComponent>,
    private router: Router,
    private appInfoService: AppInfoService,
    private priceAsService: PriceAsService,
    @Inject(MAT_DIALOG_DATA) public data: PriceAsInfo,
  ) { }

  ngOnInit(): void {
    this.appStrings = this.appInfoService.appStrings;
    this.currencySymbol = this.appInfoService.currencySymbol;
    this.retrieveQuotes();
  }

  retrieveQuotes(filterValues?: LastQuotesFilters) {
    this.isLoading = true;
    this.priceAsService
      .getLastQuotes(
        filterValues,
        this.data.accountManager.employeeId,
        this.data.customer?.id
      )
      .subscribe((quoteResponse: any) => {
        this.isLoading = false;
        if (filterValues) {
          this.quoteList = this.reduceToTenResults(quoteResponse as QuoteListResponse[]);
        } else {
          this.quoteList = quoteResponse.quotes;
        }
      });
  }

  /**
   * Reduces quotes results to 10 when there are more exact+partial results
   * @param quoteResponse array with exact and partial responses
   * @returns an array of 10 or less quotes
   */
  reduceToTenResults(quoteResponse: QuoteListResponse[]) {
    let lastTenQuotes;
    const maxLength = 10;
    // Exact search quotes response
    const exactQuotesLength = quoteResponse[0].quotes.length;
    // Partial search quotes response
    const partialQuotesLength = quoteResponse[1].quotes.length;

    if (exactQuotesLength === maxLength) {
      lastTenQuotes = quoteResponse[0].quotes;
    } else if (exactQuotesLength < maxLength && partialQuotesLength) {
      const reducedPartial = quoteResponse[1].quotes.splice(0, maxLength - exactQuotesLength);
      lastTenQuotes = quoteResponse[0].quotes.concat(reducedPartial);
    } else {
      lastTenQuotes = quoteResponse[0].quotes;
    }

    return lastTenQuotes;
  }

  addToQuote(quote: LastQuoteListItem) {
    this.priceAsService.quoteInfo = {
      product: {
        productNumber: this.data.productNumber,
        quantity: this.data.formValues.quantity
      },
      quoteId: quote.id
    };
    this.router.navigate([`/quotes/${quote.id}`]);
  }

  close() {
    this.dialogRef.close();
  }
}
